import styled from 'styled-components';
import { BodySmReg } from '@seed-health/tokens';

export const RatingWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-8);
  width: fit-content;
`;

export const Average = styled.span`
  ${BodySmReg}
  line-height: 1;
  color: var(--fill-brand);
  white-space: nowrap;
`;

export const StarsRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

const reviewsTextStyles = `
  line-height: 1;
  color: var(--fill-brand);
  text-decoration: underline;
  text-underline-offset: 2px;
  white-space: nowrap;
`;

export const ReviewsText = styled.span`
  ${BodySmReg}
  ${reviewsTextStyles}
`;

export const ReviewsLink = styled.a`
  ${BodySmReg}
  ${reviewsTextStyles}
  cursor: pointer;

  &:focus-visible {
    opacity: var(--focused);
    outline: 3px solid var(--focus-color, currentColor);
    outline-offset: var(--focus-offset, 0.3ch);
  }
`;
